import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ICartItem } from '../Shared/model/cart.model';
import { IProduct } from '../Shared/model/model/product.model';
import { ToastService } from '../Shared/services/toast.service';
import { GetSetService } from '../Shared/services/getset.serverce';
import { AppService } from '../Shared/services/app.service';
import { ApiDataService } from '../Shared/services/apidata.service';
import { HttpStatusCode, ResponseModel } from '../Shared/model/response.model';
import { Messagetype } from '../Shared/model/enum';
declare var $: any;

@Component({
  selector: 'sitebar-cart',
  templateUrl: 'sitebar-cart.component.html',
  styleUrls: ['sitebar-cart.component.scss']
})
export class SitebarCartComponent implements OnInit, OnDestroy {
  itemCount: number = 0;
  cartList: IProduct[] = [];
  public subscriptions$: Subscription[] = [];

  total: number = 0;
  mrptotal: number = 0;
  saving: number = 0;
  membershipSuggestions: any = null;
  currentLang = 'en';

  constructor(
    private getSetService: GetSetService,
    private appservice: AppService,
    private apidata: ApiDataService,
    private toast: ToastService,
    private getset: GetSetService
  ) {

    this.subscriptions$.push(
      //------------cart list change Subscribe---------------------
      this.appservice.getCart().subscribe((result) => {
        this.getCartList();
      })

    );

  }
  ngOnInit(): void {
    this.appservice.getcurrentLanguage().subscribe((lng: any) => {
      this.currentLang =  lng;
    });

    this.currentLang = this.getset.getlanguge();
    this.getCartList();
  }

  ngOnDestroy(): void {
    this.subscriptions$.forEach((subscription) => subscription.unsubscribe());
  }

  public getCartList() {
    if (this.getSetService.isloggedInUser()) {

      // const url = `/api/product/getProductInCart`;
      const url = `Cart/GetCartList`;
      this.apidata
        .getData(url)
        .subscribe((response: ResponseModel<any>) => {
          if (response.status === HttpStatusCode.OK) {
            // this.cartList = response.data.productList;
            this.cartList = response.data;
            this.total = 0;
            this.mrptotal = 0;
            this.saving = 0;

            this.itemCount = this.cartList.length;
            // this.membershipSuggestions = response.data.memberShipSuggestion;

            this.cartList.forEach((cart) => {
              if (cart) {
                cart.isInCart = true;
              }
              this.mrptotal += cart.mrp * cart.quantity;
              this.total += cart.offerPrice * cart.quantity;
            });

            this.saving = this.mrptotal - this.total;
            this.appservice.setCartStatus({
              amount: this.total,
              itemcount: this.cartList.length,
            });

          } else {
            this.appservice.setCartStatus({ amount: 0, itemcount: 0 });
            this.itemCount = 0;
            this.membershipSuggestions = null;
            this.mrptotal  = 0;
            this.total  = 0;
            this.saving = 0;
            this.cartList = [];
          }
        });
    } else {
      // get  temp  Cart list
      const tempcartList = this.getSetService.getTempCartList();
      // console.log(tempcartList);
      if (tempcartList != null) {
        this.cartList = tempcartList;
        this.total = 0;
        this.cartList.forEach((cart) => {
          // this.grandTotal += cart.mrp * cart.size;
          // this.subTotal += cart.offerPrice * cart.size;
        });
      } else {
        this.cartList = [];
        this.membershipSuggestions = null;
        this.mrptotal  = 0;
        this.total  = 0;
        this.saving = 0;
      }
    }
  }


  removecart(item: ICartItem) {
    const isUserLogin = this.getSetService.isloggedInUser();
    if (isUserLogin) {
      // add to database
      // if (this.getSetService.getArea()?.isServiceAvailable) {


        const url = `Cart/RemoveCart?ProductId=${item.productId}`;
        this.apidata
          .getData(url)
          .subscribe((response: ResponseModel<any>) => {
            if (response.status === HttpStatusCode.OK) {
               this.toast.showToast(Messagetype.sucess, 'info', 'Item successfully removed from cart.');
              this.getCartList();
              this.appservice.setCart(true);
            } else if (
              response.status === HttpStatusCode.INTERNAL_SERVER_ERROR
            ) {

               this.toast.showToast(Messagetype.fail, 'info', `${response.statusMessage} `);

            } else {
               this.toast.showToast(Messagetype.fail, 'info', `${response.statusMessage} `);
            }
          });
      // } else {

      //   this.toast.showToast(Messagetype.fail, 'info', `Service not available in this area.`);
      // }


    } else {

      // add to temp cart
    }
  }

  closeSubscriptionMessage(){
    $('#alertMsg').addClass('collapse');
  }

  public saveForLater(cartItem: any): void{

    const url = `SaveForLater/AddSaveForLater?ProductId=${cartItem.id}`;
    this.apidata.getData(url).subscribe(
      (response: ResponseModel<any>) => {
        if(response.status === HttpStatusCode.OK){
           this.toast.showToast(Messagetype.sucess, 'info', `Product added in save for later`);
          this.getCartList();
        } else {
           this.toast.showToast(Messagetype.fail, 'info', `${response.statusMessage} `);
        }
      });
  }
}
